import React, { useState, useEffect } from "react";
import "../styles/CombinedStepper.css";
import heroBg from "../assets/images/HeroBanner.png";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import { Button, OverlayTrigger, Popover } from "react-bootstrap";
import { FaEye, FaEyeSlash, FaInfoCircle } from "react-icons/fa";
import { countryCodes } from "../constants/countryCodes";
function dataURLToFile(dataurl, filename) {
  let arr = dataurl.split(","),
    mime = arr[0].match(/:(.*?);/)[1],
    bstr = atob(arr[1]),
    n = bstr.length,
    u8arr = new Uint8Array(n);
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }
  return new File([u8arr], filename, { type: mime });
}
function OldMemberForm() {
  const [membershipType, setMembershipType] = useState("full");
  const baseUrl = process.env.REACT_APP_BASEURL;

  // State for countries, states, districts, and institutions
  const [countries, setCountries] = useState([]);
  const [statesPermanent, setStatesPermanent] = useState([]);
  const [districtsPermanent, setDistrictsPermanent] = useState([]);
  const [statesCorrespondence, setStatesCorrespondence] = useState([]);
  const [districtsCorrespondence, setDistrictsCorrespondence] = useState([]);
  const [institutions, setInstitutions] = useState([]);
const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  const togglePasswordVisibility = () => setShowPassword((prev) => !prev);
  const toggleConfirmPasswordVisibility = () =>
    setShowConfirmPassword((prev) => !prev);
  const [formData, setFormData] = useState({
    name: "",
    previous_name: "",
    nametobe_printed: "",
    dob: "",
    email: "",
    phone: "",
    countryCode: "+91",
    password: "",
    confirm_password: "",
    gender: "",
    flat_house_building: "",
    colony_street_locality: "",
    landmark: "",
    country: "",
    state: "",
    district: "",
    pincode: "",
    same_address: false,
    co_flat_house_building: "",
    Co_colony_street_locality: "",
    co_landmark: "",
    Co_country: "",
    Co_state: "",
    Co_district: "",
    Co_pincode: "",
    member_name: "",
    ug_institution: "",
    ug_degree: "",
    ug_non_accredited_college_name: "",
    pg_non_accredited_college_name: "",
    ug_university: "",
    ug_completion_date: "",
    pg_institution: "",
    pg_institution_abroad: "",
    pg_degree: "",
    pg_specialization: "",
    pg_other_specialization: "",
    pg_completion_date: "",
    qualification: "",
    other_qualification: "",
    other_institution: "",
    other_specialization: "",
    research_area: "",
    other_completion_date: "",
    file_url: null,
    file_url_dataurl: null,
    file_url_name: null,
    provisional_certificate: null,
    provisional_certificate_dataurl: null,
    provisional_certificate_name: null,
    internship_completion_certficate: null,
    internship_completion_certficate_dataurl: null,
    internship_completion_certficate_name: null,
    Id_card: null,
    Id_card_dataurl: null,
    Id_card_name: null,
    aadhaar_passport: "",
    address: "",
    profile_photo: null,
    profile_photo_dataurl: null,
    profile_photo_name: null,
    membership_type: "full",
    // Old member specific fields
    iotr: "",
    liscenceNo: "",
    old_certificate: null,
    old_iotr_certificate: null,
    old_id_card: null,
    createdAt: "",
    valid_till: "",
    old_certificate_issued_date: "",
  });

  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [apiError, setApiError] = useState(null);
  const navigate = useNavigate();
  const location = useLocation();
  useEffect(() => {
    const savedFormData = localStorage.getItem("membershipFormData");
    const navigationFormData = location.state?.formData;
    let initialFormData = { ...formData };

    // Prioritize navigation state formData if available, otherwise use localStorage
    if (navigationFormData) {
      initialFormData = { ...initialFormData, ...navigationFormData };
      setMembershipType(navigationFormData.membership_type || "full");
    } else if (savedFormData) {
      const parsedData = JSON.parse(savedFormData);
      initialFormData = { ...initialFormData, ...parsedData };
      setMembershipType(parsedData.membership_type || "full");
    }

    setFormData(initialFormData);
  }, [location.state]);
  // Fetch countries and institutions on component mount
  useEffect(() => {
    const fetchCountries = async () => {
      try {
        const response = await axios.get(`${baseUrl}/countries`, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        });
        console.log("Countries API Response:", response.data);

        if (
          response.data &&
          response.data.success &&
          Array.isArray(response.data.data)
        ) {
          setCountries(response.data.data);
          console.log("Countries set:", response.data.data);
        } else {
          console.error("Unexpected response structure:", response.data);
          setCountries([]);
        }
      } catch (error) {
        console.error(
          "Error fetching countries:",
          error.response?.data || error.message
        );
        setCountries([]);
      }
    };

    const fetchInstitutions = async () => {
      try {
        const response = await axios.get(`${baseUrl}/getallinstitution`, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        });
        console.log("Institutions API Response:", response.data);

        if (
          response.data &&
          response.data.success &&
          Array.isArray(response.data.data)
        ) {
          setInstitutions(response.data.data);
          console.log("Institutions set:", response.data.data);
        } else {
          console.error("Unexpected response structure:", response.data);
          setInstitutions([]);
        }
      } catch (error) {
        console.error(
          "Error fetching institutions:",
          error.response?.data || error.message
        );
        setInstitutions([]);
      }
    };

    fetchCountries();
    fetchInstitutions();
  }, [baseUrl]);

  // Fetch states for PERMANENT address when country changes
  useEffect(() => {
    const fetchStatesPermanent = async () => {
      if (!formData.country) {
        setStatesPermanent([]);
        setDistrictsPermanent([]);
        setFormData((prev) => ({
          ...prev,
          state: "",
          district: "",
        }));
        return;
      }

      try {
        const response = await axios.get(
          `${baseUrl}/states/${formData.country}`,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`,
            },
          }
        );
        console.log("States API Response for Permanent:", response.data);

        if (response.data) {
          if (Array.isArray(response.data)) {
            setStatesPermanent(response.data);
          } else if (response.data.data && Array.isArray(response.data.data)) {
            setStatesPermanent(response.data.data);
          } else if (
            response.data.success &&
            Array.isArray(response.data.data)
          ) {
            setStatesPermanent(response.data.data);
          } else {
            console.error("Unexpected response structure:", response.data);
            setStatesPermanent([]);
          }
        } else {
          console.error("No data in response");
          setStatesPermanent([]);
        }

        setDistrictsPermanent([]);
        setFormData((prev) => ({
          ...prev,
          state: "",
          district: "",
        }));
      } catch (error) {
        console.error(
          "Error fetching states for permanent address:",
          error.response?.data || error.message
        );
        setStatesPermanent([]);
        setDistrictsPermanent([]);
      }
    };
    fetchStatesPermanent();
  }, [formData.country, baseUrl]);

  // Fetch districts for PERMANENT address when state changes
  useEffect(() => {
    const fetchDistrictsPermanent = async () => {
      if (!formData.country || !formData.state) {
        setDistrictsPermanent([]);
        setFormData((prev) => ({ ...prev, district: "" }));
        return;
      }

      try {
        const response = await axios.get(
          `${baseUrl}/districts/${formData.country}/${formData.state}`,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`,
            },
          }
        );
        console.log("Districts API Response for Permanent:", response.data);

        if (response.data) {
          if (Array.isArray(response.data)) {
            setDistrictsPermanent(response.data);
          } else if (response.data.data && Array.isArray(response.data.data)) {
            setDistrictsPermanent(response.data.data);
          } else if (
            response.data.success &&
            Array.isArray(response.data.data)
          ) {
            setDistrictsPermanent(response.data.data);
          } else {
            console.error("Unexpected response structure:", response.data);
            setDistrictsPermanent([]);
          }
        } else {
          console.error("No data in response");
          setDistrictsPermanent([]);
        }

        setFormData((prev) => ({ ...prev, district: "" }));
      } catch (error) {
        console.error(
          "Error fetching districts for permanent address:",
          error.response?.data || error.message
        );
        setDistrictsPermanent([]);
      }
    };
    fetchDistrictsPermanent();
  }, [formData.country, formData.state, baseUrl]);

  // Fetch states for CORRESPONDENCE address when country changes
  useEffect(() => {
    const fetchStatesCorrespondence = async () => {
      if (formData.same_address) {
        setStatesCorrespondence(statesPermanent);
        setDistrictsCorrespondence(districtsPermanent);
        return;
      }

      if (!formData.Co_country) {
        setStatesCorrespondence([]);
        setDistrictsCorrespondence([]);
        setFormData((prev) => ({
          ...prev,
          Co_state: "",
          Co_district: "",
        }));
        return;
      }

      try {
        const response = await axios.get(
          `${baseUrl}/states/${formData.Co_country}`,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`,
            },
          }
        );
        console.log("States API Response for Correspondence:", response.data);

        if (response.data) {
          if (Array.isArray(response.data)) {
            setStatesCorrespondence(response.data);
          } else if (response.data.data && Array.isArray(response.data.data)) {
            setStatesCorrespondence(response.data.data);
          } else if (
            response.data.success &&
            Array.isArray(response.data.data)
          ) {
            setStatesCorrespondence(response.data.data);
          } else {
            console.error("Unexpected response structure:", response.data);
            setStatesCorrespondence([]);
          }
        } else {
          console.error("No data in response");
          setStatesCorrespondence([]);
        }

        setDistrictsCorrespondence([]);
        setFormData((prev) => ({
          ...prev,
          Co_state: "",
          Co_district: "",
        }));
      } catch (error) {
        console.error(
          "Error fetching states for correspondence address:",
          error.response?.data || error.message
        );
        setStatesCorrespondence([]);
        setDistrictsCorrespondence([]);
      }
    };
    fetchStatesCorrespondence();
  }, [
    formData.Co_country,
    formData.same_address,
    statesPermanent,
    districtsPermanent,
    baseUrl,
  ]);

  // Fetch districts for CORRESPONDENCE address when state changes
  useEffect(() => {
    const fetchDistrictsCorrespondence = async () => {
      if (formData.same_address) {
        setDistrictsCorrespondence(districtsPermanent);
        return;
      }

      if (!formData.Co_country || !formData.Co_state) {
        setDistrictsCorrespondence([]);
        setFormData((prev) => ({ ...prev, Co_district: "" }));
        return;
      }

      try {
        const response = await axios.get(
          `${baseUrl}/districts/${formData.Co_country}/${formData.Co_state}`,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`,
            },
          }
        );
        console.log(
          "Districts API Response for Correspondence:",
          response.data
        );

        if (response.data) {
          if (Array.isArray(response.data)) {
            setDistrictsCorrespondence(response.data);
          } else if (response.data.data && Array.isArray(response.data.data)) {
            setDistrictsCorrespondence(response.data.data);
          } else if (
            response.data.success &&
            Array.isArray(response.data.data)
          ) {
            setDistrictsCorrespondence(response.data.data);
          } else {
            console.error("Unexpected response structure:", response.data);
            setDistrictsCorrespondence([]);
          }
        } else {
          console.error("No data in response");
          setDistrictsCorrespondence([]);
        }

        setFormData((prev) => ({ ...prev, Co_district: "" }));
      } catch (error) {
        console.error(
          "Error fetching districts for correspondence address:",
          error.response?.data || error.message
        );
        setDistrictsCorrespondence([]);
      }
    };
    fetchDistrictsCorrespondence();
  }, [
    formData.Co_country,
    formData.Co_state,
    formData.same_address,
    districtsPermanent,
    baseUrl,
  ]);

  const handleMembershipChange = (e) => {
    const newMembershipType = e.target.value;
    setMembershipType(newMembershipType);
    setFormData((prev) => ({ ...prev, membership_type: newMembershipType }));
    setErrors({});
    setApiError(null);
  };

  const handleMemberLogin = () => {
    navigate("/member-login");
  };

  const handleEdcclogin = () => {
    navigate("/edcc-login");
  };

  // const handleInputChange = (e) => {
  //   const { name, value } = e.target;

  //   let newValue = value;

  //   // Restrict degree & university fields to only letters and spaces
  //   if (
  //     [
  //       "ug_degree",
  //       "ug_university",
  //       "pg_degree",
  //       "qualification",
  //       "other_institution",
  //       "research_area",
  //     ].includes(name)
  //   ) {
  //     newValue = newValue.replace(/[^a-zA-Z\s]/g, "");
  //   }

  //   setFormData((prev) => {
  //     const updatedData = { ...prev, [name]: newValue };

  //     if (name === "aadhaar_passport" && membershipType === "associate") {
  //       updatedData.aadhaar_passport = newValue;
  //     }

  //     return updatedData;
  //   });

  //   if (name === "password" || name === "confirm_password") {
  //     setErrors((prev) => ({
  //       ...prev,
  //       confirm_password: undefined,
  //     }));
  //   }
  // };

  const handleInputChange = (e) => {
  const { name, value } = e.target;
  let processedValue = value;
  let error = '';

  // Real-time validation based on field type
  switch (name) {
    case 'email':
      if (value && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)) {
        error = 'Invalid email format';
      } else if (value) {
        // Check for temporary/disposable email domains
        const blockedDomains = [
          "yopmail.com", "tempmail.com", "mailinator.com", "guerrillamail.com",
          "10minutemail.com", "trashmail.com", "dispostable.com", "fakeinbox.com",
          "getnada.com", "moakt.com", "sharklasers.com", "maildrop.cc", "mintemail.com"
        ];
        const domain = value.split("@")[1]?.toLowerCase();
        if (domain && blockedDomains.includes(domain)) {
          error = 'Temporary or disposable email addresses are not allowed';
        }
      }
      break;

    case 'password':
      if (value && value.length < 8) {
        error = 'Password must be at least 8 characters long';
      } else if (value && !/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]/.test(value)) {
        error = 'Password must contain uppercase, lowercase, number and special character';
      }
      break;

    case 'confirm_password':
      if (value && value !== formData.password) {
        error = 'Passwords do not match';
      }
      break;

    case 'name':
    case 'previous_name':
    case 'nametobe_printed':
      if (value && !/^[A-Za-z\s]+$/.test(value)) {
        error = 'Only alphabets and spaces are allowed';
        processedValue = value.replace(/[^A-Za-z\s]/g, '');
      }
      break;

    case 'phone':
      processedValue = value.replace(/\D/g, '');
      if (processedValue && (processedValue.length < 7 || processedValue.length > 15)) {
        error = "Mobile number must be between 7 and 15 digits";
      } else if (processedValue && !/^[0-9]+$/.test(processedValue)) {
        error = "Mobile number must contain only digits";
      }
      break;

    case 'pincode':
    case 'Co_pincode':
      processedValue = value.replace(/\D/g, '');
      if (processedValue && processedValue.length !== 6) {
        error = 'Pincode must be exactly 6 digits';
      }
      break;

    case 'aadhaar_passport':
      if (value) {
        if (/^\d+$/.test(value)) {
          // Aadhaar validation
          if (value.length !== 12) {
            error = 'Aadhaar number must be exactly 12 digits';
          }
        } else {
          // Passport validation
          if (!/^[A-Za-z0-9]{6,10}$/.test(value)) {
            error = 'Passport number must be 6-10 alphanumeric characters';
          }
        }
      }
      break;

    case 'liscenceNo':
      // Remove any spaces from the input
      processedValue = value.replace(/\s/g, '').toUpperCase();
      if (value.includes(' ') || value.includes('\t')) {
        error = "License number cannot contain spaces";
      } else if (processedValue && !/^L-/.test(processedValue)) {
        error = "License number must start with 'L-'";
      }
      break;

    case 'iotr':
      processedValue = value.replace(/\D/g, '');
      if (processedValue && (processedValue.length < 5 || processedValue.length > 10)) {
        error = 'IOTR must be 5-10 digits';
      }
      break;

    case 'dob':
      if (value) {
        const selectedDate = new Date(value + 'T00:00:00');
        const today = new Date();
        today.setHours(0, 0, 0, 0);
        
        if (selectedDate.getTime() > today.getTime()) {
          error = 'Date of Birth cannot be in the future';
        } else {
          const sixteenYearsAgo = new Date();
          sixteenYearsAgo.setFullYear(sixteenYearsAgo.getFullYear() - 16);
          sixteenYearsAgo.setHours(0, 0, 0, 0);
          
          if (selectedDate.getTime() > sixteenYearsAgo.getTime()) {
            error = 'You must be at least 16 years old';
          }
        }
      }
      break;

    case 'ug_completion_date':
    case 'pg_completion_date':
    case 'other_completion_date':
      if (value) {
        const selectedDate = new Date(value + 'T00:00:00');
        const today = new Date();
        today.setHours(0, 0, 0, 0);
        
        if (selectedDate.getTime() > today.getTime()) {
          error = 'Completion date cannot be in the future';
        }
      }
      break;

    case 'createdAt':
      if (value) {
        const selectedDate = new Date(value + 'T00:00:00');
        const today = new Date();
        today.setHours(0, 0, 0, 0);
        
        if (selectedDate.getTime() > today.getTime()) {
          error = 'Valid From date cannot be in the future';
        } else if (formData.old_certificate_issued_date) {
          const issuedDate = new Date(formData.old_certificate_issued_date + 'T00:00:00');
          if (selectedDate.getTime() >= issuedDate.getTime()) {
            error = 'Valid From date must be before Old Certificate Issued Date';
          }
        }
      }
      break;

    case 'old_certificate_issued_date':
      if (value) {
        const selectedDate = new Date(value + 'T00:00:00');
        const today = new Date();
        today.setHours(0, 0, 0, 0);
        
        if (selectedDate.getTime() > today.getTime()) {
          error = 'Certificate issued date cannot be in the future';
        } else if (formData.createdAt) {

          
          const createdAt = new Date(formData.createdAt + 'T00:00:00');
          if (selectedDate.getTime() < createdAt.getTime()) {
            error = 'Certificate issued date must be after Valid From (Created Date)';
          }
        }
      }
      break;

    case 'ug_degree':
    case 'ug_non_accredited_college_name':
    case 'pg_non_accredited_college_name':
    case 'ug_university':
    case 'pg_degree':
    case 'qualification':
    case 'other_institution':
    case 'research_area':
      if (value && !/^[A-Za-z\s]+$/.test(value)) {
        error = 'Only alphabets and spaces are allowed';
        processedValue = value.replace(/[^A-Za-z\s]/g, '');
      }
      break;
  }

  // Update form data
  setFormData((prev) => {
    const updatedData = { ...prev, [name]: processedValue };

    // Handle cascading updates
    if (name === "country") {
      updatedData.state = "";
      updatedData.district = "";
    } else if (name === "state") {
      updatedData.district = "";
    } else if (name === "Co_country") {
      updatedData.Co_state = "";
      updatedData.Co_district = "";
    } else if (name === "Co_state") {
      updatedData.Co_district = "";
    } else if(name === "ug_institution" && ugInstitutionName !== "Others" ) {
      updatedData.ug_non_accredited_college_name = "";
    } else if(name === "pg_institution" && pgInstitutionName !== "Others" ) {
      updatedData.pg_non_accredited_college_name = "";
    }

    // Special handling for associate membership
    if (name === "aadhaar_passport" && membershipType === "associate") {
      updatedData.aadhaar_passport = processedValue;
    }

    // Clear related date errors when dates change
    if (name === "createdAt") {
      // Clear old_certificate_issued_date error when createdAt changes
      setErrors((prev) => {
        const newErrors = { ...prev };
        delete newErrors.old_certificate_issued_date;
        return newErrors;
      });
    } else if (name === "old_certificate_issued_date") {
      // Clear createdAt error when old_certificate_issued_date changes
      setErrors((prev) => {
        const newErrors = { ...prev };
        delete newErrors.createdAt;
        return newErrors;
      });
    }

    return updatedData;
  });

  // Set or clear error for this field
  setErrors((prev) => {
    const newErrors = { ...prev };
    
    if (error) {
      newErrors[name] = error;
    } else {
      delete newErrors[name];
    }

    // Clear confirm_password error when password changes
    if (name === "password" && newErrors.confirm_password) {
      if (formData.confirm_password === processedValue) {
        delete newErrors.confirm_password;
      }
    }

    return newErrors;
  });
};

//   const handleFileChange = (e, field) => {
//     if (e.target.files.length === 0) {
//       // User clicked cancel - don't clear the existing file
//       e.target.value = ""; // Reset the input to trigger onChange on next selection
//       return;
//     }

//     const file = e.target.files[0];
//     const newErrors = { ...errors };

//     const maxSize = 10 * 1024 * 1024;
//     if (file.size > maxSize) {
//       newErrors[field] = `File size exceeds 10MB`;
//       setErrors(newErrors);
//       setFormData((prev) => ({ ...prev, [field]: null }));
//       e.target.value = ""; // Clear the input
//     } else {
//       const validFormats =
//         field === "file_url"
//           ? ["image/jpeg", "image/jpg", "image/png"]
//           : ["application/pdf"];
//       if (!validFormats.includes(file.type)) {
//         newErrors[field] =
//           field === "file_url"
//             ? "Only JPG, JPEG, or PNG files are allowed"
//             : "Only PDF files are allowed";
//         setErrors(newErrors);
//         setFormData((prev) => ({ ...prev, [field]: null }));
//         e.target.value = ""; // Clear the input
//       } else {
//         delete newErrors[field];
//         setErrors(newErrors);
//         setFormData((prev) => ({ ...prev, [field]: file }));
//       }
//     }
//   };
// const handleImageChange = (e, field) => {
//   if (e.target.files.length === 0) {
//     e.target.value = "";
//     return;
//   }

//   const file = e.target.files[0];
//   const newErrors = { ...errors };
//   const maxSize = 10 * 1024 * 1024; // 10MB

//   if (file.size > maxSize) {
//     newErrors[field] = "File size exceeds 10MB";
//     setErrors(newErrors);
//     setFormData((prev) => ({ ...prev, [field]: null }));
//     e.target.value = "";
//     return;
//   }

//   // Allow only image formats
//   const allowedFormats = ["image/jpeg", "image/jpg", "image/png"];

//   if (!allowedFormats.includes(file.type)) {
//     newErrors[field] = "Only JPG, JPEG, or PNG files are allowed";
//     setErrors(newErrors);
//     setFormData((prev) => ({ ...prev, [field]: null }));
//     e.target.value = "";
//   } else {
//     delete newErrors[field];
//     setErrors(newErrors);
//     setFormData((prev) => ({ ...prev, [field]: file }));
//   }
// };

//   const handleCheckboxChange = (e) => {
//     const { checked } = e.target;
//     setFormData((prev) => ({
//       ...prev,
//       same_address: checked,
//       ...(checked
//         ? {
//             co_flat_house_building: prev.flat_house_building,
//             Co_colony_street_locality: prev.colony_street_locality,
//             co_landmark: prev.landmark,
//             Co_country: prev.country,
//             Co_state: prev.state,
//             Co_district: prev.district,
//             Co_pincode: prev.pincode,
//           }
//         : {
//             co_flat_house_building: "",
//             Co_colony_street_locality: "",
//             co_landmark: "",
//             Co_country: "",
//             Co_state: "",
//             Co_district: "",
//             Co_pincode: "",
//           }),
//     }));

//     if (checked) {
//       setStatesCorrespondence(statesPermanent);
//       setDistrictsCorrespondence(districtsPermanent);
//     } else {
//       setStatesCorrespondence([]);
//       setDistrictsCorrespondence([]);
//     }
//   };





const handleFileChange = (e, field) => {
  if (e.target.files.length === 0) {
    // If file input is cleared, reset related state but do not enforce mandatory error
    setErrors(prev => ({ ...prev, [field]: "" }));
    setFormData((prev) => ({ ...prev, [field]: null }));
    e.target.value = "";
    return;
  }

  const file = e.target.files[0];
  let error = '';

  // File size validation
  const maxSize = 10 * 1024 * 1024; // 10MB
  if (file.size > maxSize) {
    error = 'File size exceeds 10MB';
    setErrors(prev => ({ ...prev, [field]: error }));
    setFormData((prev) => ({ ...prev, [field]: null }));
    e.target.value = "";
    return;
  }

  // File type validation
  const validFormats = field === "file_url" 
    ? ["image/jpeg", "image/jpg", "image/png"]
    : field === "old_certificate" || field === "old_iotr_certificate" || field === "old_id_card"
    ? ["application/pdf", "image/jpeg", "image/jpg", "image/png"]
    : ["application/pdf"];

  if (!validFormats.includes(file.type)) {
    error = field === "file_url"
      ? "Only JPG, JPEG, or PNG files are allowed"
      : field === "old_certificate" || field === "old_iotr_certificate" || field === "old_id_card"
      ? "Only PDF, JPG, JPEG, or PNG files are allowed"
      : "Only PDF files are allowed";
    setErrors(prev => ({ ...prev, [field]: error }));
    setFormData((prev) => ({ ...prev, [field]: null }));
    e.target.value = "";
    return;
  }

  // Clear error and set file
  setErrors(prev => {
    const newErrors = { ...prev };
    delete newErrors[field];
    return newErrors;
  });
  setFormData((prev) => ({ ...prev, [field]: file }));
};

// Enhanced handleImageChange with real-time validation
const handleImageChange = (e, field) => {
  if (e.target.files.length === 0) {
    e.target.value = "";
    return;
  }

  const file = e.target.files[0];
  let error = '';

  // File size validation
  const maxSize = 10 * 1024 * 1024; // 10MB
  if (file.size > maxSize) {
    error = "File size exceeds 10MB";
    setErrors(prev => ({ ...prev, [field]: error }));
    setFormData((prev) => ({ ...prev, [field]: null }));
    e.target.value = "";
    return;
  }

  // File type validation
  const allowedFormats = ["image/jpeg", "image/jpg", "image/png"];
  if (!allowedFormats.includes(file.type)) {
    error = "Only JPG, JPEG, or PNG files are allowed";
    setErrors(prev => ({ ...prev, [field]: error }));
    setFormData((prev) => ({ ...prev, [field]: null }));
    e.target.value = "";
    return;
  }

  // Clear error and set file
  setErrors(prev => {
    const newErrors = { ...prev };
    delete newErrors[field];
    return newErrors;
  });
  setFormData((prev) => ({ ...prev, [field]: file }));
};

// Enhanced handleRadioChange with validation
const handleRadioChange = (e, field) => {
  const { value } = e.target;
  setFormData((prev) => ({ ...prev, [field]: value }));
  
  // Clear error when radio is selected
  setErrors((prev) => {
    const newErrors = { ...prev };
    delete newErrors[field];
    return newErrors;
  });
};

// Enhanced handleCheckboxChange with validation
const handleCheckboxChange = (e) => {
  const { checked } = e.target;
  
  setFormData((prev) => ({
    ...prev,
    same_address: checked,
    ...(checked
      ? {
          co_flat_house_building: prev.flat_house_building,
          Co_colony_street_locality: prev.colony_street_locality,
          co_landmark: prev.landmark,
          Co_country: prev.country,
          Co_state: prev.state,
          Co_district: prev.district,
          Co_pincode: prev.pincode,
        }
      : {
          co_flat_house_building: "",
          Co_colony_street_locality: "",
          co_landmark: "",
          Co_country: "",
          Co_state: "",
          Co_district: "",
          Co_pincode: "",
        }),
  }));

  // Clear correspondence address errors when checkbox is checked
  if (checked) {
    setErrors((prev) => {
      const newErrors = { ...prev };
      delete newErrors.co_flat_house_building;
      delete newErrors.Co_colony_street_locality;
      delete newErrors.co_landmark;
      delete newErrors.Co_country;
      delete newErrors.Co_state;
      delete newErrors.Co_district;
      delete newErrors.Co_pincode;
      return newErrors;
    });
  }

  if (checked) {
    setStatesCorrespondence(statesPermanent);
    setDistrictsCorrespondence(districtsPermanent);
  } else {
    setStatesCorrespondence([]);
    setDistrictsCorrespondence([]);
  }
};
  // const handleRadioChange = (e, field) => {
  //   const { value } = e.target;
  //   setFormData((prev) => ({ ...prev, [field]: value }));
  // };

  const getPasswordRules = (password) => {
  return [
    {
      label: "At least 8 characters",
      valid: password.length >= 8,
    },
    {
      label: "Includes uppercase letter",
      valid: /[A-Z]/.test(password),
    },
    {
      label: "Includes lowercase letter",
      valid: /[a-z]/.test(password),
    },
    {
      label: "Includes a number",
      valid: /[0-9]/.test(password),
    },
    {
      label: "Includes special character (!@#$%^&*)",
      valid: /[!@#$%^&*]/.test(password),
    },
  ];
};


  const validate = async () => {
    console.log("Validating form data:", formData);
    const newErrors = {};
    let firstErrorField = null; // Track the first field with an error

    // Common validations for both membership types
    if (!formData.name.trim()) {
      newErrors.name = "Full Name is required";
      firstErrorField = firstErrorField || "name";
    } else if (!/^[A-Za-z\s]+$/.test(formData.name.trim())) {
      newErrors.name = "Full Name can only contain letters and spaces";
      firstErrorField = firstErrorField || "name";
    }

    if (!formData.nametobe_printed?.trim()) {
      newErrors.nametobe_printed = "Preferred Certificate Name is required";
      firstErrorField = firstErrorField || "nametobe_printed";
    } else if (!/^[A-Za-z\s]+$/.test(formData.nametobe_printed.trim())) {
      newErrors.nametobe_printed =
        "Preferred Certificate Name can only contain letters and spaces";
      firstErrorField = firstErrorField || "nametobe_printed";
    }

    if (!formData.dob) {
      newErrors.dob = "Date of Birth is required";
      firstErrorField = firstErrorField || "dob";
    } else {
      const selectedDate = new Date(formData.dob + "T00:00:00"); // Ensure local time
      const today = new Date();
      today.setHours(0, 0, 0, 0); // Reset time to start of day
      if (selectedDate.getTime() > today.getTime()) {
        newErrors.dob = "Date of Birth cannot be in the future";
        firstErrorField = firstErrorField || "dob";
      } else {
        const sixteenYearsAgo = new Date();
        sixteenYearsAgo.setFullYear(sixteenYearsAgo.getFullYear() - 16);
        sixteenYearsAgo.setHours(0, 0, 0, 0);
        if (selectedDate.getTime() > sixteenYearsAgo.getTime()) {
          newErrors.dob = "You must be at least 16 years old";
          firstErrorField = firstErrorField || "dob";
        }
      }
    }
if (!formData.email.trim()) {
  newErrors.email = "Email Address is required";
  firstErrorField = firstErrorField || "email";
} else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) {
  newErrors.email = "Invalid email format";
  firstErrorField = firstErrorField || "email";
} else {
  // 🔹 Block temporary or disposable email domains
  const blockedDomains = [
    "yopmail.com",
    "tempmail.com",
    "mailinator.com",
    "guerrillamail.com",
    "10minutemail.com",
    "trashmail.com",
    "dispostable.com",
    "fakeinbox.com",
    "getnada.com",
    "moakt.com",
    "sharklasers.com",
    "maildrop.cc",
    "mintemail.com",
  ];

  const domain = formData.email.split("@")[1].toLowerCase();

  if (blockedDomains.includes(domain)) {
    newErrors.email = "Temporary or disposable email addresses are not allowed";
    firstErrorField = firstErrorField || "email";
  }
}



    if (!formData.phone.trim()) {
      newErrors.phone = "Mobile Number is required";
      firstErrorField = firstErrorField || "phone";
    }
// 🔹 Password validation
if (formData.password) {
  if (formData.password.length < 8) {
    newErrors.password = "Password must be at least 8 characters long";
    firstErrorField = firstErrorField || "password";
  } else if (
    !/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]/.test(
      formData.password
    )
  ) {
    newErrors.password =
      "Password must contain uppercase, lowercase, number and special character";
    firstErrorField = firstErrorField || "password";
  }
} else {
  newErrors.password = "Password is required";
  firstErrorField = firstErrorField || "password";
}

// 🔹 Confirm password validation
if (formData.confirm_password) {
  if (formData.confirm_password !== formData.password) {
    newErrors.confirm_password = "Passwords do not match";
    firstErrorField = firstErrorField || "confirm_password";
  }
} else {
  newErrors.confirm_password = "Confirm Password is required";
  firstErrorField = firstErrorField || "confirm_password";
}


    // Validations for Life Membership
    if (membershipType === "full") {
      //    if (!formData.previous_name.trim()) {
      //   newErrors.previous_name = "Previous Name is required";
      //   firstErrorField = firstErrorField || "previous_name";
      // } else if (!/^[A-Za-z\s]+$/.test(formData.previous_name.trim())) {
      //   newErrors.previous_name = "Previous Name can only contain letters and spaces";
      //   firstErrorField = firstErrorField || "previous_name";
      // }

      if (!formData.gender) {
        newErrors.gender = "Gender is required";
        firstErrorField = firstErrorField || "gender";
      }
      if (!formData.flat_house_building?.trim()) {
        newErrors.flat_house_building = "Flat/House No is required";
        firstErrorField = firstErrorField || "flat_house_building";
      }
      if (!formData.colony_street_locality?.trim()) {
        newErrors.colony_street_locality = "Colony/Street/Locality is required";
        firstErrorField = firstErrorField || "colony_street_locality";
      }
      if (!formData.landmark?.trim()) {
        newErrors.landmark = "Landmark is required";
        firstErrorField = firstErrorField || "landmark";
      }
      if (!formData.country) {
        newErrors.country = "Country is required";
        firstErrorField = firstErrorField || "country";
      }
      if (!formData.state) {
        newErrors.state = "State is required";
        firstErrorField = firstErrorField || "state";
      }
      // if (!formData.district) {
      //   newErrors.district = "District is required";
      //   firstErrorField = firstErrorField || "district";
      // }
      if (!formData.pincode?.trim()) {
        newErrors.pincode = "Pincode is required";
        firstErrorField = firstErrorField || "pincode";
      } else if (!/^\d{6}$/.test(formData.pincode.trim())) {
        newErrors.pincode = "Pincode must be 6 digits";
        firstErrorField = firstErrorField || "pincode";
      }
      // if (!formData.member_name?.trim()) {
      //   newErrors.member_name = "Student Membership Name is required (enter 'None' if not applicable)";
      //   firstErrorField = firstErrorField || "member_name";
      // }
      if (!formData.co_flat_house_building?.trim() && !formData.same_address) {
        newErrors.co_flat_house_building =
          "Correspondence Flat/House No is required";
        firstErrorField = firstErrorField || "co_flat_house_building";
      }
      if (
        !formData.Co_colony_street_locality?.trim() &&
        !formData.same_address
      ) {
        newErrors.Co_colony_street_locality =
          "Correspondence Colony/Street/Locality is required";
        firstErrorField = firstErrorField || "Co_colony_street_locality";
      }
      if (!formData.co_landmark?.trim() && !formData.same_address) {
        newErrors.co_landmark = "Correspondence Landmark is required";
        firstErrorField = firstErrorField || "co_landmark";
      }
      if (!formData.Co_country && !formData.same_address) {
        newErrors.Co_country = "Correspondence Country is required";
        firstErrorField = firstErrorField || "Co_country";
      }
      if (!formData.Co_state && !formData.same_address) {
        newErrors.Co_state = "Correspondence State is required";
        firstErrorField = firstErrorField || "Co_state";
      }
      // if (!formData.Co_district && !formData.same_address) {
      //   newErrors.Co_district = "Correspondence District is required";
      //   firstErrorField = firstErrorField || "Co_district";
      // }
      if (!formData.Co_pincode?.trim() && !formData.same_address) {
        newErrors.Co_pincode = "Correspondence Pincode is required";
        firstErrorField = firstErrorField || "Co_pincode";
      } else if (
        !formData.same_address &&
        formData.Co_pincode &&
        !/^\d{6}$/.test(formData.Co_pincode.trim())
      ) {
        newErrors.Co_pincode = "Correspondence Pincode must be 6 digits";
        firstErrorField = firstErrorField || "Co_pincode";
      }
      if (!formData.ug_institution) {
        newErrors.ug_institution = "UG Institution is required";
        firstErrorField = firstErrorField || "ug_institution";
      }
      if (!formData.ug_degree?.trim()) {
        newErrors.ug_degree = "UG Degree is required";
        firstErrorField = firstErrorField || "ug_degree";
      }
      if (!formData.ug_university?.trim()) {
        newErrors.ug_university = "UG University is required";
        firstErrorField = firstErrorField || "ug_university";
      }
      if (!formData.ug_completion_date) {
        newErrors.ug_completion_date = "UG Completion Date is required";
        firstErrorField = firstErrorField || "ug_completion_date";
      } else {
        const selectedDate = new Date(
          formData.ug_completion_date + "T00:00:00"
        );
        const today = new Date();
        today.setHours(0, 0, 0, 0);
        if (selectedDate.getTime() > today.getTime()) {
          newErrors.ug_completion_date =
            "UG Completion Date cannot be in the future";
          firstErrorField = firstErrorField || "ug_completion_date";
        }
      }

      // if (!formData.pg_institution) {
      //   newErrors.pg_institution = "PG Institution is required";
      //   firstErrorField = firstErrorField || "pg_institution";
      // }
      // if (!formData.pg_institution_abroad?.trim()) {
      //   newErrors.pg_institution_abroad = "PG Institution Abroad is required (enter 'None' if not applicable)";
      //   firstErrorField = firstErrorField || "pg_institution_abroad";
      // }
      // if (!formData.pg_degree?.trim()) {
      //   newErrors.pg_degree = "PG Degree is required";
      //   firstErrorField = firstErrorField || "pg_degree";
      // }
      // if (!formData.pg_specialization) {
      //   newErrors.pg_specialization = "PG Specialization is required";
      //   firstErrorField = firstErrorField || "pg_specialization";
      // }
      // if (!formData.pg_other_specialization?.trim()) {
      //   newErrors.pg_other_specialization = "Other Specialization is required (enter 'None' if not applicable)";
      //   firstErrorField = firstErrorField || "pg_other_specialization";
      // }
      //   if (!formData.pg_completion_date) {
      //   newErrors.pg_completion_date = "PG Completion Date is required";
      //   firstErrorField = firstErrorField || "pg_completion_date";
      // } else {
      //   const selectedDate = new Date(formData.pg_completion_date + 'T00:00:00'); // Ensure local time
      //   const today = new Date();
      //   today.setHours(0, 0, 0, 0); // Reset time to start of day
      //   if (selectedDate.getTime() > today.getTime()) {
      //     newErrors.pg_completion_date = "PG Completion Date cannot be in the future";
      //     firstErrorField = firstErrorField || "pg_completion_date";
      //   }
      // }
      // if (!formData.other_qualification) {
      //   newErrors.other_qualification = "Other Qualification is required";
      //   firstErrorField = firstErrorField || "other_qualification";
      // }
      // if (!formData.qualification?.trim()) {
      //   newErrors.qualification = "Qualification Name is required";
      //   firstErrorField = firstErrorField || "qualification";
      // }
      // if (!formData.other_institution?.trim()) {
      //   newErrors.other_institution = "Other Institution is required";
      //   firstErrorField = firstErrorField || "other_institution";
      // }
      // if (!formData.research_area?.trim()) {
      //   newErrors.research_area = "Research Area is required";
      //   firstErrorField = firstErrorField || "research_area";
      // }
      // if (!formData.other_completion_date) {
      //   newErrors.other_completion_date = "Other Completion Date is required";
      //   firstErrorField = firstErrorField || "other_completion_date";
      // }
      // Old member specific validations
      if (!formData.iotr?.trim()) {
        newErrors.iotr = "IOTR number is required";
        firstErrorField = firstErrorField || "iotr";
      } else if (!/^\d{5,10}$/.test(formData.iotr.trim())) {
        newErrors.iotr = "IOTR must be 5-10 digits";
        firstErrorField = firstErrorField || "iotr";
      }
      if (!formData.liscenceNo?.trim()) {
        newErrors.liscenceNo = "License number is required";
        firstErrorField = firstErrorField || "liscenceNo";
      } else {
        const licenseValue = formData.liscenceNo.trim();
        // Check if license number contains spaces
        if (/\s/.test(licenseValue)) {
          newErrors.liscenceNo = "License number cannot contain spaces";
          firstErrorField = firstErrorField || "liscenceNo";
        } else if (!/^L-/i.test(licenseValue)) {
          newErrors.liscenceNo = "License number must start with 'L-'";
          firstErrorField = firstErrorField || "liscenceNo";
        }
      }
      if (!formData.createdAt) {
        newErrors.createdAt = "Created date (Valid From) is required";
        firstErrorField = firstErrorField || "createdAt";
      }
      if (!formData.valid_till) {
        newErrors.valid_till = "Valid till date is required";
        firstErrorField = firstErrorField || "valid_till";
      } else if (formData.createdAt && formData.valid_till) {
        const validFrom = new Date(formData.createdAt + "T00:00:00");
        const validTill = new Date(formData.valid_till + "T00:00:00");
        if (validTill.getTime() <= validFrom.getTime()) {
          newErrors.valid_till = "Valid till date must be after Valid from date";
          firstErrorField = firstErrorField || "valid_till";
        }
      }
      // Old Life Certificate is optional - only validate if file is uploaded
      if (formData.old_certificate) {
        const file = formData.old_certificate;
        if (file.size > 10 * 1024 * 1024) {
          newErrors.old_certificate = "File size must be less than 10MB";
          firstErrorField = firstErrorField || "old_certificate";
        } else if (!["application/pdf", "image/jpeg", "image/jpg", "image/png"].includes(file.type)) {
          newErrors.old_certificate = "Only PDF, JPG, JPEG, or PNG files are allowed";
          firstErrorField = firstErrorField || "old_certificate";
        }
      }
      // Old IOTR certificate is optional - only validate if file is uploaded
      if (formData.old_iotr_certificate) {
        const file = formData.old_iotr_certificate;
        if (file.size > 10 * 1024 * 1024) {
          newErrors.old_iotr_certificate = "File size must be less than 10MB";
          firstErrorField = firstErrorField || "old_iotr_certificate";
        } else if (!["application/pdf", "image/jpeg", "image/jpg", "image/png"].includes(file.type)) {
          newErrors.old_iotr_certificate = "Only PDF, JPG, JPEG, or PNG files are allowed";
          firstErrorField = firstErrorField || "old_iotr_certificate";
        }
      }

      if(ugInstitutionName === "Others" && !formData.ug_non_accredited_college_name?.trim()) {
        newErrors.ug_non_accredited_college_name = "Institution name is required";
        firstErrorField = firstErrorField || "ug_non_accredited_college_name";
      }
      
      // Old ID Card is optional - only validate if file is uploaded
      if (formData.old_id_card) {
        const file = formData.old_id_card;
        if (file.size > 10 * 1024 * 1024) {
          newErrors.old_id_card = "File size must be less than 10MB";
          firstErrorField = firstErrorField || "old_id_card";
        } else if (!["application/pdf", "image/jpeg", "image/jpg", "image/png"].includes(file.type)) {
          newErrors.old_id_card = "Only PDF, JPG, JPEG, or PNG files are allowed";
          firstErrorField = firstErrorField || "old_id_card";
        }
      }
      if (!formData.old_certificate_issued_date) {
        newErrors.old_certificate_issued_date = "Old certificate issued date is required";
        firstErrorField = firstErrorField || "old_certificate_issued_date";
      } else if (formData.createdAt && formData.old_certificate_issued_date) {
        const createdAt = new Date(formData.createdAt + "T00:00:00");
        const issuedDate = new Date(formData.old_certificate_issued_date + "T00:00:00");
        if (issuedDate.getTime() < createdAt.getTime()) {
          newErrors.old_certificate_issued_date = "Certificate issued date must be after Valid From (Created Date)";
          firstErrorField = firstErrorField || "old_certificate_issued_date";
        }
      }

      [
        "file_url",
        "Id_card",
      ].forEach((field) => {
        if (formData[`${field}_error`]) {
          newErrors[field] = errors[field] || `File size exceeds 10MB`; // Preserve the size error
        } else if (!formData[field]) {
          newErrors[field] = `${
            field === "file_url"
              ? "Color Passport Size Photo"
              : field === "provisional_certificate"
              ? "Provisional Certificate"
              : field === "internship_completion_certficate"
              ? "Internship Completion Certificate"
              : "ID Card"
          } is required`;
          firstErrorField = firstErrorField || field;
        } else if (
          field === "file_url" &&
          !["image/jpeg", "image/jpg", "image/png"].includes(
            formData[field].type
          )
        ) {
          newErrors[field] = "Only JPG, JPEG, or PNG files are allowed";
          firstErrorField = firstErrorField || field;
        } else if (
          field !== "file_url" &&
          formData[field].type !== "application/pdf"
        ) {
          newErrors[field] = "Only PDF files are allowed";
          firstErrorField = firstErrorField || field;
        } else if (formData[field].size > 10 * 1024 * 1024) {
          newErrors[field] = "File size must be less than 10MB";
          firstErrorField = firstErrorField || field;
        }
      });
    } else {
      // Validations for Associate Membership
      if (!formData.aadhaar_passport?.trim()) {
        newErrors.aadhaar_passport = "Aadhaar or Passport Number is required";
        firstErrorField = firstErrorField || "aadhaar_passport";
      } else {
        const value = formData.aadhaar_passport.trim();
        if (/^\d+$/.test(value)) {
          if (value.length !== 12) {
            newErrors.aadhaar_passport =
              "Aadhaar number must be exactly 12 digits";
            firstErrorField = firstErrorField || "aadhaar_passport";
          }
        } else {
          if (!/^[A-Za-z0-9]{6,10}$/.test(value)) {
            newErrors.aadhaar_passport =
              "Passport number must be 6-10 alphanumeric characters";
            firstErrorField = firstErrorField || "aadhaar_passport";
          }
        }
      }
      if (!formData.address?.trim()) {
        newErrors.address = "Address is required";
        firstErrorField = firstErrorField || "address";
      }
if (!formData.profile_photo) {
  newErrors.profile_photo = "Profile Photo is required";
  firstErrorField = firstErrorField || "profile_photo";
} else {
  const file = formData.profile_photo;

  const allowedTypes = [
    "image/jpeg",
    "image/jpg",
    "image/png",
    "application/pdf",
  ];

  const allowedExtensions = ["jpg", "jpeg", "png", "pdf"];
  const fileExtension = file.name.split(".").pop().toLowerCase();

  if (!allowedTypes.includes(file.type) && !allowedExtensions.includes(fileExtension)) {
    newErrors.profile_photo = "Only JPG, JPEG, PNG, or PDF files are allowed";
    firstErrorField = firstErrorField || "profile_photo";
  } else if (file.size > 10 * 1024 * 1024) {
    newErrors.profile_photo = "File size must be less than 10MB";
    firstErrorField = firstErrorField || "profile_photo";
  }
}
    }

    if (!baseUrl) {
      setApiError(
        "Base URL is not configured. Please check your environment variables."
      );
      setLoading(false);
      return { errors: newErrors, firstErrorField };
    }

    try {
      setLoading(true);
      setApiError(null);

      const validationEndpoint =
        membershipType === "full"
          ? "getAllLifememberships"
          : "getAllAssociateMemberships";

      const apiUrl = `${baseUrl.replace(/\/$/, "")}/${validationEndpoint}`;
      // Note: The API call is incomplete; add actual API call if needed
    } catch (err) {
      console.error("Validation API Error:", err);
      setApiError("Failed to validate membership details. Please try again.");
    } finally {
      setLoading(false);
    }

    return { errors: newErrors, firstErrorField };
  };

  const handleNext = async () => {
    try {
      console.log("Form Data Before Validation:", formData);
      const { errors: validationErrors, firstErrorField } = await validate();
      setErrors(validationErrors);
      if (Object.keys(validationErrors).length > 0) {
        if (firstErrorField) {
          const inputElement = document.querySelector(
            `[name="${firstErrorField}"]`
          );
          if (inputElement) {
            inputElement.scrollIntoView({
              behavior: "smooth",
              block: "center",
            });
            inputElement.focus();
          }
        }
        return;
      }
      if (!baseUrl) {
        setApiError(
          "Base URL is not configured. Please check your environment variables."
        );
        setLoading(false);
        return;
      }
      setLoading(true);
      setApiError(null);

      // Prepare form data for submission
      const formDataToSend = new FormData();
      Object.entries(formData).forEach(([key, value]) => {
        if (
          value !== null &&
          value !== undefined &&
          value !== "" &&
          !(value instanceof File)
        ) {
          formDataToSend.append(key, value);
        }
      });
      // For old members, always use full membership file fields plus old_certificate, old_iotr_certificate, and old_id_card
      const fileFields = [
        "file_url",
        "Id_card",
        "old_certificate",
        "old_iotr_certificate",
        "old_id_card",
      ];
      fileFields.forEach((field) => {
        if (formData[field]) {
          formDataToSend.append(field, formData[field]);
        }
      });
      const endpoint = "createoldmember";
      const apiUrl = `${baseUrl}/${endpoint}`;

      const response = await axios.post(apiUrl, formDataToSend, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      });

      // Clear cached form data after successful submission
      localStorage.removeItem("membershipFormData");

      // Reset form and navigate on success
      setFormData({
        name: "",
        previous_name: "",
        nametobe_printed: "",
        dob: "",
        email: "",
        phone: "",
        password: "",
        confirm_password: "",
        gender: "",
        flat_house_building: "",
        colony_street_locality: "",
        landmark: "",
        country: "",
        state: "",
        district: "",
        pincode: "",
        same_address: false,
        co_flat_house_building: "",
        Co_colony_street_locality: "",
        co_landmark: "",
        Co_country: "",
        Co_state: "",
        Co_district: "",
        Co_pincode: "",
        ug_institution: "",
        member_name: "",
        ug_degree: "",
        ug_university: "",
        ug_completion_date: "",
        pg_institution: "",
        pg_institution_abroad: "",
        pg_degree: "",
        pg_specialization: "",
        pg_other_specialization: "",
        pg_completion_date: "",
        qualification: "",
        other_qualification: "",
        other_institution: "",
        other_specialization: "",
        research_area: "",
        other_completion_date: "",
        file_url: null,
        provisional_certificate: null,
        internship_completion_certficate: null,
        Id_card: null,
        aadhaar_passport: "",
        address: "",
        profile_photo: null,
        membership_type: "full",
        // Old member specific fields
        iotr: "",
        liscenceNo: "",
        old_certificate: null,
        old_iotr_certificate: null,
        old_id_card: null,
        createdAt: "",
        valid_till: "",
        old_certificate_issued_date: "",
      });
      // Old members don't need payment - redirect to success or home
      navigate("/", {
        state: {
          message: "Old member registration submitted successfully. Your application is pending approval.",
        },
      });
    } catch (err) {
      console.error("API Error:", err);
      const responseMessage = err.response?.data?.message || "";
      const responseErrors = err.response?.data?.errors;

      // Show backend field-level validation errors directly on inputs.
      if (responseErrors && typeof responseErrors === "object") {
        const mappedErrors = {};
        if (responseErrors.liscenceNo) {
          mappedErrors.liscenceNo = responseErrors.liscenceNo;
        }
        if (responseErrors.iotr) {
          mappedErrors.iotr = responseErrors.iotr;
        }

        if (Object.keys(mappedErrors).length > 0) {
          setErrors((prev) => ({ ...prev, ...mappedErrors }));
          const firstField = mappedErrors.liscenceNo ? "liscenceNo" : "iotr";
          const inputElement = document.querySelector(`[name="${firstField}"]`);
          if (inputElement) {
            inputElement.scrollIntoView({ behavior: "smooth", block: "center" });
            inputElement.focus();
          }
          setApiError(responseMessage || "Please correct the highlighted fields.");
          return;
        }
      }

      // Handle specific email existence errors
      if (err.response?.status === 400) {
        const message = responseMessage;

        if (/iotr/i.test(message)) {
          setApiError("IOTR number already exists. Please verify and try again.");
        } else if (/licen[cs]e/i.test(message) || /liscence/i.test(message)) {
          setApiError(
            "License number already exists. Please verify and try again."
          );
        } else if (message.includes("Associate Membership")) {
          setApiError(
            <div className="error-message-container">
              <h6>Email Already Registered</h6>
              <p>
                This email address is already registered with an Associate
                Membership.
              </p>
              <p>Please use a different email address or contact support.</p>
            </div>
          );
        } else if (err.response.data.message.includes("Life Membership")) {
          setApiError(
            <div className="error-message-container">
              <h6>Email Already Registered</h6>
              <p>
                This email address is already registered with a Life Membership.
              </p>
              <p>Please use a different email address or contact support.</p>
            </div>
          );
        } else {
          setApiError("Failed to submit membership. Please try again.");
        }
      } else {
        setApiError(
          "An error occurred while submitting your application. Please try again later."
        );
      }
    } finally {
      setLoading(false);
    }
  };

  const ugInstitutionName = institutions.find(el => el._id === formData.ug_institution)?.name_and_place_institution;
  const pgInstitutionName = institutions.find(el => el._id === formData.pg_institution)?.name_and_place_institution;

  return (
    <>
      {/* Fixed Hero Section */}
      <section
        className="hero-fixed"
        style={{ backgroundImage: `url(${heroBg})` }}
      >
        <div className="hero-scroll-content">
          <div className="hero-content-home poppins-regular">
            <h1 className="hero-heading">
              All India Occupational Therapists' Association
            </h1>
          </div>
        </div>
      </section>

      {/* Scrollable Content Container */}
      <div className="scrollable-content-home">
        <div className="content-container">
          <div className="content">
            <h2>Registration Form</h2>
            <div className="details-note-div">
              <p className="details-note">
                Details of the applicants : (Please fill in capital letters)
              </p>
            </div>
            {apiError && (
              <div className="error-message alert alert-danger mb-4">
                <div className="d-flex align-items-center ">
                  <i className="fas fa-exclamation-triangle me-2 mb-2"></i>
                  <h6 className=" mt-1">Registration Error</h6>
                </div>
                <div className="api-error-body mb-2 text-start">
                  {typeof apiError === "string" ? (
                    <p className="mb-0">{apiError}</p>
                  ) : (
                    apiError
                  )}
                </div>
                <p className="mb-0 medium opacity-75 text-start">
                  Please check your information and try again. If the issue
                  persists, contact support.
                </p>
              </div>
            )}
            {loading && (
              <div className="loading-message alert alert-info mb-4">
                <div className="d-flex align-items-center">
                  <div
                    className="spinner-border spinner-border-sm me-2"
                    role="status"
                  >
                    <span className="visually-hidden">Loading...</span>
                  </div>
                  <span>Processing your registration...</span>
                </div>
              </div>
            )}
            <form>
              {membershipType === "full" ? (
                <>
                  <div className="form-row-stepper">
                    <div className="form-group-stepper">
                      <label>Membership Type :</label>
                      <select
                        value={membershipType}
                        onChange={handleMembershipChange}
                        className={errors.membership_type ? "error-border" : ""}
                      >
                        <option value="full">Life Membership</option>
                        {/* <option value="associate">Associate Membership</option> */}
                      </select>
                    </div>
                    <div className="form-group-stepper">
                      <label>
                        Full Name :<span className="required-asterisk">*</span>
                      </label>
                      <input
                        type="text"
                        name="name"
                        value={formData.name}
                        onChange={handleInputChange}
                        placeholder="Enter Your Full Name"
                        className={errors.name ? "error-border" : ""}
                      />
                      {errors.name && <p className="error">{errors.name}</p>}
                    </div>
                    <div className="form-group-stepper">
                      <label>Previous Name :</label>
                      <input
                        type="text"
                        name="previous_name"
                        value={formData.previous_name}
                        onChange={handleInputChange}
                        placeholder="Previous Name (If married)"
                        className={errors.previous_name ? "error-border" : ""}
                      />
                      {errors.previous_name && (
                        <p className="error">{errors.previous_name}</p>
                      )}
                    </div>
                  </div>
                  <div className="form-row-stepper">
                    <div className="form-group-stepper">
                      <label>
                        Preferred Certificate Name :
                        <span className="required-asterisk">*</span>
                      </label>
                      <input
                        type="text"
                        name="nametobe_printed"
                        value={formData.nametobe_printed}
                        onChange={handleInputChange}
                        placeholder="Certificate Name"
                        className={
                          errors.nametobe_printed ? "error-border" : ""
                        }
                      />
                      <p className="certificate-note">
                        (Do not enter 'Dr'. It will be added automatically to the certificate.)
                      </p>
                      {errors.nametobe_printed && (
                        <p className="error">{errors.nametobe_printed}</p>
                      )}
                    </div>
                    <div className="form-group-stepper">
                      <label>
                        Date of Birth :
                        <span className="required-asterisk">*</span>
                      </label>
                      <input
                        type="date"
                        name="dob"
                        value={formData.dob}
                        onChange={handleInputChange}
                        placeholder="Enter Date of Birth"
                        max={new Date().toISOString().split("T")[0]}
                        className={errors.dob ? "error-border" : ""}
                      />
                      {errors.dob && <p className="error">{errors.dob}</p>}
                    </div>
                    <div className="form-group-stepper">
                      <label>
                        E-mail Address :
                        <span className="required-asterisk">*</span>
                      </label>
                      <input
                        type="email"
                        name="email"
                        value={formData.email}
                        onChange={handleInputChange}
                        placeholder="Enter Your E-mail Address"
                        className={errors.email ? "error-border" : ""}
                      />
                      {errors.email && <p className="error">{errors.email}</p>}
                    </div>
                  </div>
                  <div className="form-row-stepper">
                    <div className="form-group-stepper" style={{ position: "relative" }}>
<label style={{ display: "flex", alignItems: "center", gap: "6px" }}>
  Password :<span className="required-asterisk">*</span>
  <OverlayTrigger
    trigger={["hover", "focus"]}
    placement="right"
    overlay={
      <Popover id="password-popover">
        <Popover.Header as="h3">Password Requirements</Popover.Header>
        <Popover.Body>
          {getPasswordRules(formData.password).map((rule, index) => (
            <div
            key={index}
            style={{
              display: "flex",
              alignItems: "center",
              gap: "6px",
              color: rule.valid ? "green" : "red",
            }}
          >
            {rule.valid ? "✓" : "✗"} {rule.label}
            
            </div>
              ))}
        </Popover.Body>
      </Popover>
    }
  >
    <span
      style={{
        display: "inline-flex",
        alignItems: "center",
        cursor: "pointer",
        color: "#0a58ca",
      }}
    >
      <FaInfoCircle size={14} />
    </span>
  </OverlayTrigger>
</label>

        <input
          type={showPassword ? "text" : "password"}
          name="password"
          value={formData.password}
          onChange={handleInputChange}
          placeholder="Enter Your Password"
          className={errors.password ? "error-border" : ""}
          style={{ paddingRight: "35px" }}
        />
        <span
          onClick={() => setShowPassword(!showPassword)}
          style={{
            position: "absolute",
            right: "10px",
            top: "44px",
            cursor: "pointer",
            color: "black",
          }}
        >
          {showPassword ? <FaEyeSlash /> : <FaEye />}
        </span>
        {errors.password && <p className="error">{errors.password}</p>}
      </div>

      {/* Confirm Password Field */}
      <div className="form-group-stepper" style={{ position: "relative" }}>
        <label>
          Confirm Password :<span className="required-asterisk">*</span>
        </label>
        <input
          type={showConfirmPassword ? "text" : "password"}
          name="confirm_password"
          value={formData.confirm_password}
          onChange={handleInputChange}
          placeholder="Confirm Your Password"
          className={errors.confirm_password ? "error-border" : ""}
          style={{ paddingRight: "35px" }}
        />
        <span
          onClick={() => setShowConfirmPassword(!showConfirmPassword)}
          style={{
            position: "absolute",
            right: "10px",
            top: "44px",
            cursor: "pointer",
            color: "black",
          }}
        >
          {showConfirmPassword ? <FaEye /> : <FaEyeSlash />}
        </span>
        {errors.confirm_password && (
          <p className="error">{errors.confirm_password}</p>
        )}
      </div>
                                        <div className="form-group-stepper">
                      <label>
                        Mobile Number :
                        <span className="required-asterisk">*</span>
                      </label>
                      <div className="input-wrapper" style={{ height: "45px" }}>
                        
                        <select
                          name="countryCode"
                          value={formData.countryCode}
                          onChange={handleInputChange}
                          className="country-code"
                          style={{ width: "120px" }}
                        >
                          {countryCodes.map((c) => (
                            <option key={c.iso} value={c.code}>
                              {c.code} ({c.name})
                            </option>
                          ))}
                        </select>

                        <input
                          type="tel"
                          name="phone"
                          value={formData.phone}
                          onChange={handleInputChange}
                          placeholder="Enter Your Mobile Number"
                          className={`mobile-input ${errors.phone ? "error-border" : ""}`}
                        />
                      </div>
                      {errors.phone && <p className="error">{errors.phone}</p>}
                    </div>
                  </div>
                  <div className="form-row-stepper">

                    <div className="form-group-stepper gender-group">
                      <label>
                        Gender :<span className="required-asterisk">*</span>
                      </label>

                      <div className="radio-group">
                        <label className="radio-group-gender">
                          <input
                            type="radio"
                            name="gender"
                            value="male"
                            checked={formData.gender === "male"}
                            onChange={(e) => handleRadioChange(e, "gender")}
                            className={errors.gender ? "error-border" : ""}
                          />
                          Male
                        </label>

                        <label className="radio-group-gender">
                          <input
                            type="radio"
                            name="gender"
                            value="female"
                            checked={formData.gender === "female"}
                            onChange={(e) => handleRadioChange(e, "gender")}
                            className={errors.gender ? "error-border" : ""}
                          />
                          Female
                        </label>

                        <label className="radio-group-gender">
                          <input
                            type="radio"
                            name="gender"
                            value="other"
                            checked={formData.gender === "other"}
                            onChange={(e) => handleRadioChange(e, "gender")}
                            className={errors.gender ? "error-border" : ""}
                          />
                          Other
                        </label>
                      </div>

                      {errors.gender && <p className="error">{errors.gender}</p>}
                    </div>
                    <div className="form-group-stepper"></div>
                  </div>
                  <h3 className="address-permanent">Permanent Address :</h3>
                  <div className="form-row-stepper">
                    <div className="form-group-stepper">
                      <label>
                        Flat/House No/ Floor/ Building :
                        <span className="required-asterisk">*</span>
                      </label>
                      <input
                        type="text"
                        name="flat_house_building"
                        value={formData.flat_house_building}
                        onChange={handleInputChange}
                        placeholder="Enter Your Flat/House No/ Floor/ Building"
                        className={
                          errors.flat_house_building ? "error-border" : ""
                        }
                      />
                      {errors.flat_house_building && (
                        <p className="error">{errors.flat_house_building}</p>
                      )}
                    </div>
                    <div className="form-group-stepper">
                      <label>
                        Colony/Street/Locality :
                        <span className="required-asterisk">*</span>
                      </label>
                      <input
                        type="text"
                        name="colony_street_locality"
                        value={formData.colony_street_locality}
                        onChange={handleInputChange}
                        placeholder="Enter Your Colony/Street/Locality"
                        className={
                          errors.colony_street_locality ? "error-border" : ""
                        }
                      />
                      {errors.colony_street_locality && (
                        <p className="error">{errors.colony_street_locality}</p>
                      )}
                    </div>
                    <div className="form-group-stepper">
                      <label>
                        Landmark :<span className="required-asterisk">*</span>
                      </label>
                      <input
                        type="text"
                        name="landmark"
                        value={formData.landmark}
                        onChange={handleInputChange}
                        placeholder="Enter Your Landmark"
                        className={errors.landmark ? "error-border" : ""}
                      />
                      {errors.landmark && (
                        <p className="error">{errors.landmark}</p>
                      )}
                    </div>
                  </div>
                  <div className="form-row-stepper">
                    <div className="form-group-stepper">
                      <label>
                        Country :<span className="required-asterisk">*</span>
                      </label>
                      <select
                        name="country"
                        value={formData.country}
                        onChange={handleInputChange}
                        className={errors.country ? "error-border" : ""}
                      >
                        <option value="">Select Country</option>
                        {countries.map((country) => (
                          <option key={country._id} value={country._id}>
                            {country.country_name}
                          </option>
                        ))}
                      </select>
                      {errors.country && (
                        <p className="error">{errors.country}</p>
                      )}
                    </div>
                    <div className="form-group-stepper">
                      <label>
                        State :<span className="required-asterisk">*</span>
                      </label>
                      <select
                        name="state"
                        value={formData.state}
                        onChange={handleInputChange}
                        className={errors.state ? "error-border" : ""}
                      >
                        <option value="">Select State</option>
                        {statesPermanent.map((state) => (
                          <option key={state._id} value={state._id}>
                            {state.state_name}
                          </option>
                        ))}
                      </select>
                      {errors.state && <p className="error">{errors.state}</p>}
                    </div>
                    <div className="form-group-stepper">
                      <label>
                        District :
                      </label>
                      <select
                        name="district"
                        value={formData.district}
                        onChange={handleInputChange}
                        className={errors.district ? "error-border" : ""}
                      >
                        <option value="">Select District</option>
                        {districtsPermanent.map((district) => (
                          <option key={district._id} value={district._id}>
                            {district.district_name}
                          </option>
                        ))}
                      </select>
                      {errors.district && (
                        <p className="error">{errors.district}</p>
                      )}
                    </div>
                    <div className="form-group-stepper">
                      <label>
                        Pincode :<span className="required-asterisk">*</span>
                      </label>
                      <input
                        type="text"
                        name="pincode"
                        value={formData.pincode}
                        onChange={handleInputChange}
                        placeholder="Enter Pincode"
                        className={errors.pincode ? "error-border" : ""}
                      />
                      {errors.pincode && (
                        <p className="error">{errors.pincode}</p>
                      )}
                    </div>
                  </div>
                  <div className="form-group-stepper">
                    <label>
                      If a student member of AIOTA, refer to the Student
                      Membership:
                    </label>
                    <input
                      type="text"
                      name="member_name"
                      value={formData.member_name}
                      onChange={handleInputChange}
                      placeholder="Enter Your Full Name"
                      style={{ width: "100%", maxWidth: "600px" }}
                      className={errors.member_name ? "error-border" : ""}
                    />
                    {errors.member_name && (
                      <p className="error">{errors.member_name}</p>
                    )}
                  </div>
                  <div className="form-row-stepper">
                    <div className="form-group-stepper checkbox-group">
                      <label>
                        <input
                          type="checkbox"
                          checked={formData.same_address}
                          onChange={handleCheckboxChange}
                        />{" "}
                        Same as Permanent Address
                      </label>
                    </div>
                  </div>
                  <h3 className="address-permanent">
                    Correspondence Address :
                  </h3>
                  <div className="form-row-stepper">
                    <div className="form-group-stepper">
                      <label>
                        Flat/House No/ Floor/ Building :
                        <span className="required-asterisk">*</span>
                      </label>
                      <input
                        type="text"
                        name="co_flat_house_building"
                        value={
                          formData.same_address
                            ? formData.flat_house_building
                            : formData.co_flat_house_building
                        }
                        onChange={handleInputChange}
                        placeholder="Enter Your Flat/House No/ Floor/ Building"
                        disabled={formData.same_address}
                        className={
                          errors.co_flat_house_building ? "error-border" : ""
                        }
                      />
                      {errors.co_flat_house_building && (
                        <p className="error">{errors.co_flat_house_building}</p>
                      )}
                    </div>
                    <div className="form-group-stepper">
                      <label>
                        Colony/Street/Locality :
                        <span className="required-asterisk">*</span>
                      </label>
                      <input
                        type="text"
                        name="Co_colony_street_locality"
                        value={
                          formData.same_address
                            ? formData.colony_street_locality
                            : formData.Co_colony_street_locality
                        }
                        onChange={handleInputChange}
                        placeholder="Enter Your Colony/Street/Locality"
                        disabled={formData.same_address}
                        className={
                          errors.Co_colony_street_locality ? "error-border" : ""
                        }
                      />
                      {errors.Co_colony_street_locality && (
                        <p className="error">
                          {errors.Co_colony_street_locality}
                        </p>
                      )}
                    </div>
                    <div className="form-group-stepper">
                      <label>
                        Landmark :<span className="required-asterisk">*</span>
                      </label>
                      <input
                        type="text"
                        name="co_landmark"
                        value={
                          formData.same_address
                            ? formData.landmark
                            : formData.co_landmark
                        }
                        onChange={handleInputChange}
                        placeholder="Enter Your Landmark"
                        disabled={formData.same_address}
                        className={errors.co_landmark ? "error-border" : ""}
                      />
                      {errors.co_landmark && (
                        <p className="error">{errors.co_landmark}</p>
                      )}
                    </div>
                  </div>
                  <div className="form-row-stepper">
                    <div className="form-group-stepper">
                      <label>
                        Country :<span className="required-asterisk">*</span>
                      </label>
                      <select
                        name="Co_country"
                        value={
                          formData.same_address
                            ? formData.country
                            : formData.Co_country
                        }
                        onChange={handleInputChange}
                        disabled={formData.same_address}
                        className={errors.Co_country ? "error-border" : ""}
                      >
                        <option value="">Select Country</option>
                        {countries.map((country) => (
                          <option key={country._id} value={country._id}>
                            {country.country_name}
                          </option>
                        ))}
                      </select>
                      {errors.Co_country && (
                        <p className="error">{errors.Co_country}</p>
                      )}
                    </div>
                    <div className="form-group-stepper">
                      <label>
                        State :<span className="required-asterisk">*</span>
                      </label>
                      {formData.same_address ? (
                        <input
                          type="text"
                          value={
                            statesPermanent.find(
                              (state) => state._id === formData.state
                            )?.state_name || ""
                          }
                          readOnly
                          disabled
                          className={errors.Co_state ? "error-border" : ""}
                        />
                      ) : (
                        <select
                          name="Co_state"
                          value={formData.Co_state}
                          onChange={handleInputChange}
                          disabled={formData.same_address}
                          className={errors.Co_state ? "error-border" : ""}
                        >
                          <option value="">Select State</option>
                          {statesCorrespondence.map((state) => (
                            <option key={state._id} value={state._id}>
                              {state.state_name}
                            </option>
                          ))}
                        </select>
                      )}
                      {errors.Co_state && (
                        <p className="error">{errors.Co_state}</p>
                      )}
                    </div>
                    <div className="form-group-stepper">
                      <label>
                        District :
                      </label>
                      {formData.same_address ? (
                        <input
                          type="text"
                          value={
                            districtsPermanent.find(
                              (district) => district._id === formData.district
                            )?.district_name || ""
                          }
                          readOnly
                          disabled
                          className={errors.Co_district ? "error-border" : ""}
                        />
                      ) : (
                        <select
                          name="Co_district"
                          value={formData.Co_district}
                          onChange={handleInputChange}
                          disabled={formData.same_address}
                          className={errors.Co_district ? "error-border" : ""}
                        >
                          <option value="">Select District</option>
                          {districtsCorrespondence.map((district) => (
                            <option key={district._id} value={district._id}>
                              {district.district_name}
                            </option>
                          ))}
                        </select>
                      )}
                      {errors.Co_district && (
                        <p className="error">{errors.Co_district}</p>
                      )}
                    </div>
                    <div className="form-group-stepper">
                      <label>
                        Pincode :<span className="required-asterisk">*</span>
                      </label>
                      <input
                        type="text"
                        name="Co_pincode"
                        value={
                          formData.same_address
                            ? formData.pincode
                            : formData.Co_pincode
                        }
                        onChange={handleInputChange}
                        placeholder="Enter Pincode"
                        disabled={formData.same_address}
                        className={errors.Co_pincode ? "error-border" : ""}
                      />
                      {errors.Co_pincode && (
                        <p className="error">{errors.Co_pincode}</p>
                      )}
                    </div>
                  </div>
                  <h3 className="address-permanent">Academic Details :</h3>
                  <div className="note-box">
                    <p>
                      If you are a graduate of the following colleges and
                      received your degree certificate after the mentioned year
                      (in brackets), please note that you will not be eligible
                      to apply for a life membership from AIOTA as the degree
                      year accreditation status of the colleges expired.
                    </p>
                    <ul>
                      <li>
                        {" "}
                        Jaipur Occupational Therapy College, Jaipur (Dec 2021)
                      </li>
                      <li>
                        {" "}
                        Mahatma Gandhi College of Occupational Therapy (2022)
                      </li>
                      <li>
                        {" "}
                        Department of Occupational Therapy, National Institute
                        of Locomotor Disabilities, Kolkata (Dec 2020)
                      </li>
                    </ul>
                    <p>
                      Should you have any concerns please mail us at
                      secretary@aiota.org
                    </p>
                  </div>
                  <h4 className="academic">UG Details</h4>
                  <div className="form-row-stepper">
                    <div className="form-group-stepper">
                      <label>
                        Name of Institution :
                        <span className="required-asterisk">*</span>
                      </label>
                      <select
                        name="ug_institution"
                        value={formData.ug_institution}
                        onChange={handleInputChange}
                        className={errors.ug_institution ? "error-border" : ""}
                      >
                        <option value="">Select Institution</option>
                        {institutions.map((institution) => (
                          <option key={institution._id} value={institution._id}>
                            {institution.name_and_place_institution}
                          </option>
                        ))}

                      </select>
                      {errors.ug_institution && (
                        <p className="error">{errors.ug_institution}</p>
                      )}
                    </div>
                    {ugInstitutionName === "Others" &&
                     <div className="form-group-stepper">
                      <label>
                        Name of the Institution :
                        <span className="required-asterisk">*</span>
                      </label>
                      <input
                        type="text"
                        name="ug_non_accredited_college_name"
                        value={formData.ug_non_accredited_college_name}
                        onChange={handleInputChange}
                        placeholder="Institution Name"
                        className={errors.ug_non_accredited_college_name ? "error-border" : ""}
                      />
                      {errors.ug_non_accredited_college_name && (
                        <p className="error">{errors.ug_non_accredited_college_name}</p>
                      )}
                    </div>}
                    <div className="form-group-stepper">
                      <label>
                        Name of the Degree :
                        <span className="required-asterisk">*</span>
                      </label>
                      <input
                        type="text"
                        name="ug_degree"
                        value={formData.ug_degree}
                        onChange={handleInputChange}
                        placeholder="Name of the degree"
                        className={errors.ug_degree ? "error-border" : ""}
                      />
                      {errors.ug_degree && (
                        <p className="error">{errors.ug_degree}</p>
                      )}
                    </div>
                    <div className="form-group-stepper">
                      <label>
                        Name of University :
                        <span className="required-asterisk">*</span>
                      </label>
                      <input
                        type="text"
                        name="ug_university"
                        value={formData.ug_university}
                        onChange={handleInputChange}
                        placeholder="Name of the university"
                        className={errors.ug_university ? "error-border" : ""}
                      />
                      {errors.ug_university && (
                        <p className="error">{errors.ug_university}</p>
                      )}
                    </div>
                  </div>
                  {/* <div className="form-row-stepper">
                    <div className="form-group-stepper date-completion-group">
                      <label>
                        Date of Completion :
                        <span className="required-asterisk">*</span>
                      </label>
                      <input
                        type="date"
                        name="ug_completion_date"
                        value={formData.ug_completion_date}
                        onChange={handleInputChange}
                        max={new Date().toISOString().split("T")[0]}
                        className={
                          errors.ug_completion_date ? "error-border" : ""
                        }
                      />
                      {errors.ug_completion_date && (
                        <p className="error">{errors.ug_completion_date}</p>
                      )}
                    </div>
                  </div> */}
                  <div className="form-row-stepper">
                    <div className="form-group-stepper date-completion-field">
                      <label>
                        Date of Completion :
                        <span className="required-asterisk">*</span>
                      </label>
                      <input
                        type="date"
                        name="ug_completion_date"
                        value={formData.ug_completion_date}
                        onChange={handleInputChange}
                        max={new Date().toISOString().split("T")[0]}
                        className={`small-date-field `}
                      />
                      {errors.ug_completion_date && (
                        <p className="error">{errors.ug_completion_date}</p>
                      )}
                    </div>
                    <div className="form-group-stepper"></div>
                    <div className="form-group-stepper"></div>
                </div>
                  <h4 className="academic">PG Details</h4>
                  <div className="form-row-stepper">
                    <div className="form-group-stepper">
                      <label>Institution :</label>
                      <select
                        name="pg_institution"
                        value={formData.pg_institution}
                        onChange={handleInputChange}
                        className={errors.pg_institution ? "error-border" : ""}
                      >
                        <option value="">Select Institution</option>
                        {institutions.map((institution) => (
                          <option key={institution._id} value={institution._id}>
                            {institution.name_and_place_institution}
                          </option>
                        ))}
                      </select>
                      {errors.pg_institution && (
                        <p className="error">{errors.pg_institution}</p>
                      )}
                    </div>
                    {pgInstitutionName === "Others" &&
                     <div className="form-group-stepper">
                      <label>
                        Name of the Institution :
                      </label>
                      <input
                        type="text"
                        name="pg_non_accredited_college_name"
                        value={formData.pg_non_accredited_college_name}
                        onChange={handleInputChange}
                        placeholder="Institution Name"
                        className={errors.pg_non_accredited_college_name ? "error-border" : ""}
                      />
                      {errors.pg_non_accredited_college_name && (
                        <p className="error">{errors.pg_non_accredited_college_name}</p>
                      )}
                    </div>}
                    <div className="form-group-stepper">
                      <label>
                        Name & place (abroad institution) :
                      </label>
                      <input
                        type="text"
                        name="pg_institution_abroad"
                        value={formData.pg_institution_abroad}
                        onChange={handleInputChange}
                        placeholder="Name and place of institution"
                        className={
                          errors.pg_institution_abroad ? "error-border" : ""
                        }
                      />
                      {errors.pg_institution_abroad && (
                        <p className="error">{errors.pg_institution_abroad}</p>
                      )}
                    </div>
                    <div className="form-group-stepper">
                      <label>Name of the Degree :</label>
                      <input
                        type="text"
                        name="pg_degree"
                        value={formData.pg_degree}
                        onChange={handleInputChange}
                        placeholder="Name of the degree"
                        className={errors.pg_degree ? "error-border" : ""}
                      />
                      {errors.pg_degree && (
                        <p className="error">{errors.pg_degree}</p>
                      )}
                    </div>
                  </div>
                  <div className="form-row-stepper">
                    <div className="form-group-stepper">
                      <label>Specialization :</label>
                      <select
                        name="pg_specialization"
                        value={formData.pg_specialization}
                        onChange={handleInputChange}
                        className={
                          errors.pg_specialization ? "error-border" : ""
                        }
                      >
                        <option value="">Select Specialization</option>
                        <option value="paediatrics">Paediatrics</option>
                        <option value="neurology">Neurology</option>
                        <option value="ortho">Orthopedics</option>
                        <option value="oncology">Oncology</option>
                        <option value="handrehab">Hand Rehabilitation</option>
                        <option value="rehab">Rehabilitation</option>
                        <option value="psychiatry">Psychiatry</option>
                        <option value="psychologicalrehan">
                          Psychological Rehabilitation
                        </option>
                        <option value="developement">
                          Developmental disabilities
                        </option>
                        <option value="sensory">Sensory Integration</option>
                        <option value="musculoskeletal">
                          Musculoskeletal Conditions
                        </option>
                        <option value="advanced">Advanced</option>
                      </select>
                      {errors.pg_specialization && (
                        <p className="error">{errors.pg_specialization}</p>
                      )}
                    </div>
                    <div className="form-group-stepper">
                      <label>Other Specialization :</label>
                      <input
                        type="text"
                        name="pg_other_specialization"
                        value={formData.pg_other_specialization}
                        onChange={handleInputChange}
                        placeholder="Name Other Specialization"
                        className={
                          errors.pg_other_specialization ? "error-border" : ""
                        }
                      />
                      {errors.pg_other_specialization && (
                        <p className="error">
                          {errors.pg_other_specialization}
                        </p>
                      )}
                    </div>
                    <div className="form-group-stepper">
                      <label>Date of Completion :</label>
                      <input
                        type="date"
                        name="pg_completion_date"
                        value={formData.pg_completion_date}
                        onChange={handleInputChange}
                        max={new Date().toISOString().split("T")[0]}
                        className={
                          errors.pg_completion_date ? "error-border" : ""
                        }
                      />
                      {errors.pg_completion_date && (
                        <p className="error">{errors.pg_completion_date}</p>
                      )}
                    </div>
                  </div>
                  <h4 className="academic">Other Qualifications</h4>
                  <div className="form-row-stepper">
                    <div className="form-group-stepper gender-group qualification-radio">
                      <label>Qualification :</label>
                      <div className="radio-group">
                        <div className="radio-group-gender">
                          <input
                            type="radio"
                            name="other_qualification"
                            value="PHD"
                            checked={formData.other_qualification === "PHD"}
                            onChange={(e) =>
                              handleRadioChange(e, "other_qualification")
                            }
                            className={
                              errors.other_qualification ? "error-border" : ""
                            }
                          />
                          PHD
                        </div>
                        <div className="radio-group-gender">
                          <input
                            type="radio"
                            name="other_qualification"
                            value="PGDR"
                            checked={formData.other_qualification === "PGDR"}
                            onChange={(e) =>
                              handleRadioChange(e, "other_qualification")
                            }
                            className={
                              errors.other_qualification ? "error-border" : ""
                            }
                          />
                          PGDR
                        </div>
                      </div>
                      {errors.other_qualification && (
                        <p className="error">{errors.other_qualification}</p>
                      )}
                    </div>
                    <div className="form-group-stepper">
                      <label>Other Qualification Name :</label>
                      <input
                        type="text"
                        name="qualification"
                        value={formData.qualification}
                        onChange={handleInputChange}
                        placeholder="Name of Qualification"
                        className={errors.qualification ? "error-border" : ""}
                      />
                      {errors.qualification && (
                        <p className="error">{errors.qualification}</p>
                      )}
                    </div>
                    <div className="form-group-stepper">
                      <label>Name of Other Institution :</label>
                      <input
                        type="text"
                        name="other_specialization"
                        value={formData.other_specialization}
                        onChange={handleInputChange}
                        placeholder="Name of Institution"
                        className={
                          errors.other_specialization ? "error-border" : ""
                        }
                      />
                      {errors.other_specialization && (
                        <p className="error">{errors.other_specialization}</p>
                      )}
                    </div>
                  </div>
                  <div className="form-row-stepper">
                    <div className="form-group-stepper">
                      <label>Research Area :</label>
                      <input
                        type="text"
                        name="research_area"
                        value={formData.research_area}
                        onChange={handleInputChange}
                        placeholder="Research Area"
                        className={errors.research_area ? "error-border" : ""}
                      />
                      {errors.research_area && (
                        <p className="error">{errors.research_area}</p>
                      )}
                    </div>
                    <div className="form-group-stepper">
                      <label>Date of Completion :</label>
                      <input
                        type="date"
                        name="other_completion_date"
                        value={formData.other_completion_date}
                        onChange={handleInputChange}
                        className={
                          errors.other_completion_date ? "error-border" : ""
                        }
                      />
                      {errors.other_completion_date && (
                        <p className="error">{errors.other_completion_date}</p>
                      )}
                    </div>
                  </div>
                  
                  {/* Old Member Specific Fields */}
                  <h3 className="address-permanent">Old Member Details :</h3>
                  <div className="form-row-stepper">
                    <div className="form-group-stepper">
                      <label>
                        IOTR/ACOT Number :<span className="required-asterisk">*</span>
                      </label>
                      <input
                        type="text"
                        name="iotr"
                        value={formData.iotr}
                        onChange={handleInputChange}
                        placeholder="Enter IOTR Number"
                        className={errors.iotr ? "error-border" : ""}
                      />
                      {errors.iotr && <p className="error">{errors.iotr}</p>}
                    </div>
                    <div className="form-group-stepper">
                      <label>
                        License Number (e.g., L-1234/12) :<span className="required-asterisk">*</span>
                      </label>
                      <input
                        type="text"
                        name="liscenceNo"
                        value={formData.liscenceNo}
                        onChange={handleInputChange}
                        placeholder="Enter License Number"
                        className={errors.liscenceNo ? "error-border" : ""}
                      />
                      {errors.liscenceNo && <p className="error">{errors.liscenceNo}</p>}
                    </div>
                    <div className="form-group-stepper"></div>
                  </div>
                  <div className="form-row-stepper">
                    <div className="form-group-stepper date-completion-field">
                      <label>
                        Valid From (Created Date) :<span className="required-asterisk">*</span>
                      </label>
                      <input
                        type="date"
                        name="createdAt"
                        value={formData.createdAt}
                        onChange={handleInputChange}
                        max={
                          formData.old_certificate_issued_date 
                            ? formData.old_certificate_issued_date 
                            : new Date().toISOString().split("T")[0]
                        }
                        className={errors.createdAt ? "error-border" : ""}
                      />
                      {errors.createdAt && <p className="error">{errors.createdAt}</p>}
                    </div>
                    <div className="form-group-stepper date-completion-field">
                      <label>
                        Valid Till :<span className="required-asterisk">*</span>
                      </label>
                      <input
                        type="date"
                        name="valid_till"
                        value={formData.valid_till}
                        onChange={handleInputChange}
                        min={formData.createdAt || undefined}
                        className={errors.valid_till ? "error-border" : ""}
                      />
                      {errors.valid_till && <p className="error">{errors.valid_till}</p>}
                    </div>
                    <div className="form-group-stepper date-completion-field">
                      <label>
                        Old Certificate Issued Date :<span className="required-asterisk">*</span>
                      </label>
                      <input
                        type="date"
                        name="old_certificate_issued_date"
                        value={formData.old_certificate_issued_date}
                        onChange={handleInputChange}
                        min={formData.createdAt || undefined}
                        max={new Date().toISOString().split("T")[0]}
                        className={errors.old_certificate_issued_date ? "error-border" : ""}
                      />
                      {errors.old_certificate_issued_date && <p className="error">{errors.old_certificate_issued_date}</p>}
                    </div>
                  </div>
                  
                  {/* Old Member Certificate Uploads */}
                  <h4 className="academic">
                    Old Member Certificates
                  </h4>
                  <div className="form-row-stepper">
                    <div className="form-group-stepper">
                      <label>
                        Old Life Certificate :
                      </label>
                      <input
                        type="file"
                        accept=".pdf,.jpg,.jpeg,.png"
                        onChange={(e) => handleFileChange(e, "old_certificate")}
                        className={`file-input ${
                          errors.old_certificate ? "error-border" : ""
                        }`}
                        style={{ display: "block" }}
                      />
                      {errors.old_certificate && (
                        <p className="error">{errors.old_certificate}</p>
                      )}
                    </div>
                    <div className="form-group-stepper">
                      <label>Old IOTR/ACOT Certificate :</label>
                      <input
                        type="file"
                        accept=".pdf,.jpg,.jpeg,.png"
                        onChange={(e) => handleFileChange(e, "old_iotr_certificate")}
                        className={`file-input ${
                          errors.old_iotr_certificate ? "error-border" : ""
                        }`}
                        style={{ display: "block" }}
                      />
                      {errors.old_iotr_certificate && (
                        <p className="error">{errors.old_iotr_certificate}</p>
                      )}
                    </div>
                    <div className="form-group-stepper">
                      <label>Old Aiota ID Card :</label>
                      <input
                        type="file"
                        accept=".pdf,.jpg,.jpeg,.png"
                        onChange={(e) => handleFileChange(e, "old_id_card")}
                        className={`file-input ${
                          errors.old_id_card ? "error-border" : ""
                        }`}
                        style={{ display: "block" }}
                      />
                      {errors.old_id_card && (
                        <p className="error">{errors.old_id_card}</p>
                      )}
                    </div>
                  </div>
                  
                  <div className="document-note">
                    <p className="document-p">
                      Please note: Allowed formats for Certificates and
                      Documents: PDF. Max Size: 10MB. Please ensure that the PDF
                      files are in plain PDF format and the file is not password
                      protected.
                    </p>
                  </div>
                  <h4 className="academic">
                    Upload Certificates
                    <span className="required-asterisk">*</span>
                  </h4>
                  <div className="file-upload-section">
                    <div className="form-row-stepper">
                      <div className="form-group-stepper">
                        <label>Color Passport Size Photo :</label>
                        <input
                          type="file"
                          accept=".jpg,.jpeg,.png"
                          onChange={(e) => handleFileChange(e, "file_url")}
                          className={`file-input ${
                            errors.file_url ? "error-border" : ""
                          }`}
                          style={{ display: "block" }}
                        />
                        {errors.file_url && (
                          <p className="error">{errors.file_url}</p>
                        )}
                      </div>
                      <div className="form-group-stepper">
                        <label>ID Card/Address Proof :</label>
                        <input
                          type="file"
                          accept=".pdf"
                          onChange={(e) => handleFileChange(e, "Id_card")}
                          className={`file-input ${
                            errors.Id_card ? "error-border" : ""
                          }`}
                          style={{ display: "block" }}
                        />
                        {errors.Id_card && (
                          <p className="error">{errors.Id_card}</p>
                        )}
                      </div>
                    </div>
                  </div>
                </>
              ) : (
                <>
                  <div className="form-row-stepper mb-0">
                    <div className="form-group-stepper">
                      <label>Membership Type :</label>
                      <select
                        value={membershipType}
                        onChange={handleMembershipChange}
                        className={errors.membership_type ? "error-border" : ""}
                      >
                        <option value="full">Life Membership</option>
                        <option value="associate">Associate Membership</option>
                      </select>
                    </div>
                    <div className="form-group-stepper">
                      <label>
                        Full Name :<span className="required-asterisk">*</span>
                      </label>
                      <input
                        type="text"
                        name="name"
                        value={formData.name}
                        onChange={handleInputChange}
                        placeholder="Enter Your Full Name"
                        className={errors.name ? "error-border" : ""}
                      />
                      {errors.name && <p className="error">{errors.name}</p>}
                    </div>
                    <div className="form-group-stepper">
                      <label>
                        Certificate Name :
                        <span className="required-asterisk">*</span>
                      </label>
                      <input
                        type="text"
                        name="nametobe_printed"
                        value={formData.nametobe_printed}
                        onChange={handleInputChange}
                        placeholder="Enter Name for Certificate"
                        className={
                          errors.nametobe_printed ? "error-border" : ""
                        }
                      />
                      <p className="certificate-note">
                        (Do not enter 'Dr'. It will be added automatically to the certificate.)
                      </p>
                      {errors.nametobe_printed && (
                        <p className="error">{errors.nametobe_printed}</p>
                      )}
                    </div>
                  </div>
                  <div className="form-row-stepper">
                    <div className="form-group-stepper">
                      <label>
                        Date of Birth :
                        <span className="required-asterisk">*</span>
                      </label>
                      <input
                        type="date"
                        name="dob"
                        value={formData.dob}
                        onChange={handleInputChange}
                        placeholder="Enter Date of Birth"
                        max={new Date().toISOString().split("T")[0]}
                        className={errors.dob ? "error-border" : ""}
                      />
                      {errors.dob && <p className="error">{errors.dob}</p>}
                    </div>
                    <div className="form-group-stepper">
                      <label>
                        E-mail Address :
                        <span className="required-asterisk">*</span>
                      </label>
                      <input
                        type="email"
                        name="email"
                        value={formData.email}
                        onChange={handleInputChange}
                        placeholder="Enter Your Email Address"
                        className={errors.email ? "error-border" : ""}
                      />
                      {errors.email && <p className="error">{errors.email}</p>}
                    </div>
                    <div className="form-group-stepper"></div>
                  </div>
                  <div className="form-row-stepper">
                    <div className="form-group-stepper" style={{ position: "relative" }}>
                      <label style={{ display: "flex", alignItems: "center", gap: "6px" }}>
                        Password :<span className="required-asterisk">*</span>

                        {/* Info Popover */}
                        <OverlayTrigger
                          trigger={["hover", "focus"]}
                          placement="right"
                          overlay={
                            <Popover id="password-popover">
                              <Popover.Header as="h3">Password Requirements</Popover.Header>
                              <Popover.Body>
                                {getPasswordRules(formData.password).map((rule, index) => (
                                  <div
                                    key={index}
                                    style={{
                                      display: "flex",
                                      alignItems: "center",
                                      gap: "6px",
                                      color: rule.valid ? "green" : "red",
                                      fontSize: "14px",
                                    }}
                                  >
                                    {rule.valid ? "✓" : "✗"} {rule.label}
                                  </div>
                                ))}
                              </Popover.Body>
                            </Popover>
                          }
                        >
                          <span
                            style={{
                              display: "inline-flex",
                              alignItems: "center",
                              cursor: "pointer",
                              color: "#0a58ca",
                            }}
                          >
                            <FaInfoCircle size={14} />
                          </span>
                        </OverlayTrigger>
                      </label>
                      <input
                        type={showPassword ? "text" : "password"}
                        name="password"
                        value={formData.password}
                        onChange={handleInputChange}
                        placeholder="Enter Your Password"
                        className={errors.password ? "error-border" : ""}
                      />
                      <span
                        onClick={() => setShowPassword(!showPassword)}
                        style={{
                          position: "absolute",
                          right: "10px",
                          top: "44px",
                          cursor: "pointer",
                          color: "black",
                        }}
                      >
                        {showPassword ? <FaEye /> : <FaEyeSlash />}
                      </span>                      
                      {errors.password && (
                        <p className="error">{errors.password}</p>
                      )}
                    </div>
                    <div className="form-group-stepper">
                       <div className="form-group-stepper" style={{ position: "relative" }}>
                      <label>
                        Confirm Password :
                        <span className="required-asterisk">*</span>
                      </label>
                      <input
                    type={showPassword ? "text" : "password"}
                        name="confirm_password"
                        value={formData.confirm_password}
                        onChange={handleInputChange}
                        placeholder="Confirm Your Password"
                        className={
                          errors.confirm_password ? "error-border" : ""
                        }
                        
                      />
                         <span
                        onClick={() => setShowPassword(!showPassword)}
                        style={{
                          position: "absolute",
                          right: "10px",
                          top: "44px",
                          cursor: "pointer",
                          color: "black",
                        }}
                      >
                        {showPassword ? <FaEye /> : <FaEyeSlash />}
                      </span>     
                      {errors.confirm_password && (
                        <p className="error">{errors.confirm_password}</p>
                      )}
                    </div>
                    </div>
                    <div className="form-group-stepper"></div>
                  </div>
                  <div className="form-row-stepper">
                    <div className="form-group-stepper">
                      <label>
                        Mobile Number :
                        <span className="required-asterisk">*</span>
                      </label>
                      <div className="input-wrapper">
                        <div className="country-code">
                          <span>{formData.phone_country_code || "+91"}</span>
                        </div>
                        <input
                          type="tel"
                          name="phone"
                          value={formData.phone}
                          onChange={handleInputChange}
                          placeholder="Enter Your Mobile Number"
                          className={`mobile-input ${
                            errors.phone ? "error-border" : ""
                          }`}
                        />
                      </div>
                      {errors.phone && <p className="error">{errors.phone}</p>}
                    </div>
                    <div className="form-group-stepper">
                      <label>
                        Aadhaar/Passport Number :
                        <span className="required-asterisk">*</span>
                      </label>
                      <input
                        type="text"
                        name="aadhaar_passport"
                        value={formData.aadhaar_passport}
                        onChange={handleInputChange}
                        placeholder="Enter Aadhaar or Passport Number"
                        className={
                          errors.aadhaar_passport ? "error-border" : ""
                        }
                      />
                      {errors.aadhaar_passport && (
                        <p className="error">{errors.aadhaar_passport}</p>
                      )}
                    </div>
                    <div className="form-group-stepper"></div>
                  </div>
                  <div className="form-row-stepper">
                    <div className="form-group-stepper">
                      <label>
                        Address :<span className="required-asterisk">*</span>
                      </label>
                      <textarea
                        rows={4}
                        name="address"
                        value={formData.address}
                        onChange={handleInputChange}
                        placeholder="Enter Your Address"
                        style={{
                          width: "100%",
                          padding: "8px",
                          border: "1px solid #ccc",
                          borderRadius: "4px",
                          boxSizing: "border-box",
                          fontSize: "14px",
                          resize: "vertical",
                        }}
                        className={errors.address ? "error-border" : ""}
                      ></textarea>
                      {errors.address && (
                        <p className="error">{errors.address}</p>
                      )}
                    </div>
                  </div>
                  <div className="document-note">
                    <p className="document-p">
                      Please note: Allowed formats for Profile Photo:
                      JPG/JPEG/PNG. Max Size: 10MB.
                    </p>
                  </div>
                  <h4 className="academic">
                    Document Upload<span className="required-asterisk">*</span>
                  </h4>
                  <div className="file-upload-section">
                    <div className="form-row-stepper">
<div className="form-group-stepper">
  <label>Profile Photo :</label>
  <input
    type="file"
    accept=".jpg,.jpeg,.png"  // ✅ only images
    onChange={(e) => handleImageChange(e, "profile_photo")}
    className={`file-input ${errors.profile_photo ? "error-border" : ""}`}
    style={{ display: "block" }}
  />
  {errors.profile_photo && (
    <p className="error">{errors.profile_photo}</p>
  )}
</div>

                    </div>
                  </div>
                </>
              )}
              <div className="buttons">
                <Button type="button" onClick={() => navigate(-1)}>
                  Back
                </Button>
                <Button type="button" onClick={handleNext} disabled={loading}>
                  {loading ? "Submitting..." : "Next"}
                </Button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
}

export default OldMemberForm;
